// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3p-1";
export var rateTableServiceLevelDropdown = "_3p-3";
export var rateTableTypeDropdown = "_3p-0";
export var rateTableValueModeDropdown = "_3p-2";